interface WiremockRequest {
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  path: string;
  body?: object;
}

const fetchWiremock = async ({ method, path, body }: WiremockRequest): Promise<Response> => {
  const wiremockHost = process.env.WIREMOCK_HOST || 'https://mock.qa.theverygroup.com';
  const url = `${wiremockHost}${path}`;

  try {
    const response = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
      ...(body ? { body: JSON.stringify(body) } : {}),
    });

    return response;
  } catch (error) {
    console.error(`Wiremock fetch failed for ${method} ${path}:`, error);
    throw new Error('Failed to communicate with Wiremock');
  }
};

export default fetchWiremock;
